import className from 'classnames/bind';
import styles from './PostInfo.module.scss';
import { FormatDate, Image } from '@/components';

let cx = className.bind(styles);

export function PostInfo({ date, author, className, wordCount }) {
	if (!date && !author) {
		return null;
	}

	function getReadingTime(wordCount) {
		const wordsPerMinute = 200;
		const readingTime = wordCount / wordsPerMinute;
		return Math.ceil(readingTime).toString();
	}

	return (
		<div className={cx(['post-info', className])}>
			{author?.node?.avatar?.url && (
				<div className={cx(['avatar-container'])}>
					<Image className={cx('avatar')} fill={true} src={author.node.avatar.url} objectFit="cover" objectPosition="center" />
				</div>
			)}
			<div className={cx(['post-info-details'])}>
				{author?.node?.name && <div className={cx(['post-author'])}>{author?.node?.name}</div>}
				{(date || wordCount) && (
					<small className={cx(['small-details'])}>
						{wordCount && <span className={cx(['read-length'])}>{getReadingTime(wordCount)} min read</span>}
						{date && (
							<time className={cx(['post-date'])} dateTime={date}>
								<FormatDate date={date} />
							</time>
						)}
					</small>
				)}
			</div>
		</div>
	);
}
